import { useState } from "react";
import { Button, Image, Input, XStack, YStack, TextArea } from "tamagui";
import { getImageColorStyle } from "@my/util";
import { jsx, jsxs } from "react/jsx-runtime";
const TextInputComponent = ({
  InputIcon,
  lucideIcon,
  placeHolderText,
  isPassword = false,
  height = 24,
  value,
  onChangeText,
  size,
  image,
  inputWidth = "100%",
  inputHeight = 45,
  multiline = false,
  ai = "center",
  tintColor = "none",
  borderColor,
  iconPosition = "left",
  error,
  customInputStyle = {},
  ...rest
}) => {
  const [isSecure, setIsSecure] = useState(true);
  const inputStyle = {
    ...customInputStyle
  };
  if (error) {
    inputStyle["borderColor"] = "rgb(255, 107, 107)";
  }
  const icon = lucideIcon ? lucideIcon : InputIcon ? /* @__PURE__ */jsx(Image, {
    src: InputIcon,
    style: {
      height,
      maxWidth: 20,
      ...getImageColorStyle(tintColor)
    },
    resizeMode: "contain",
    tintColor
  }) : void 0;
  const inputProps = {
    //unstyled: true,
    value,
    onChangeText,
    ...(isPassword && isSecure ? {
      type: "password"
    } : {}),
    placeholder: placeHolderText,
    style: {
      width: "80%",
      height: inputHeight,
      //paddingTop: multiline ? 13 : 0,
      //borderBottom: '2px solid black', 
      ...inputStyle
    },
    //multiline={multiline}
    fontSize: size,
    ...rest
  };
  const inputComponent = multiline ? /* @__PURE__ */jsx(TextArea, {
    ...inputProps
  }) : /* @__PURE__ */jsx(Input, {
    ...inputProps
  });
  return /* @__PURE__ */jsxs(XStack, {
    alignItems: "center",
    width: inputWidth,
    height: inputHeight,
    justifyContent: "space-between",
    paddingVertical: 10,
    children: [/* @__PURE__ */jsxs(XStack, {
      gap: 10,
      flex: 1,
      alignItems: "center",
      flexDirection: iconPosition === "left" ? "row" : "row-reverse",
      children: [icon && /* @__PURE__ */jsx(YStack, {
        height: "100%",
        justifyContent: "center",
        children: icon
      }), inputComponent]
    }), isPassword && image && /* @__PURE__ */jsx(Button, {
      height: inputHeight,
      alignItems: "center",
      justifyContent: "center",
      width: 30,
      unstyled: true,
      onPress: () => setIsSecure(!isSecure),
      children: /* @__PURE__ */jsx(Image, {
        src: isSecure ? image.eyeOn : image.eyeOff,
        style: {
          height: 13,
          width: 17
        }
      })
    })]
  });
};
export { TextInputComponent };
//# sourceMappingURL=TextInputComponent.mjs.map
